// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"718":"5a8fd602","764":"d9f3bcf9","884":"70b944aa"}[chunkId] + ".chunk.js";
};